export const SITE = {
  name: "Wholesale LVP Flooring",
  url: "https://www.wholesalelvpflooring.com",
  phone: "(980) 222-4348",
  tel: "+19802224348",
  street: "10433 Bailey Rd",
  city: "Cornelius",
  region: "NC",
  zip: "28031",
  geo: { lat: 35.457088, lng: -80.857555 },
  mapsUrl: "https://www.google.com/maps/place/Wholesale+LVP+Flooring/data=!4m2!3m1!1s0x0:0x9033f1cafb7d6e54",
  rating: { value: 4.7, count: 61 },
  hours: [
    { d: "Mon", h: "9 AM – 5 PM" },
    { d: "Tue", h: "9 AM – 5 PM" },
    { d: "Wed", h: "9 AM – 5 PM" },
    { d: "Thu", h: "9 AM – 3 PM" },
    { d: "Fri", h: "9 AM – 5 PM" },
    { d: "Sat", h: "Closed" },
    { d: "Sun", h: "Closed" },
  ],
  ogImage: "/img/og-default.jpg",
};

export const ADDRESS_LINE = `${SITE.street}, ${SITE.city}, ${SITE.region} ${SITE.zip}`;

const U = "https://images.unsplash.com/";
export const img = (id, w = 1200) => `${U}${id}?auto=format&fit=crop&w=${w}&q=68`;
export const srcSet = (id, widths = [400, 600, 800, 1200, 1600]) => widths.map((w) => `${img(id, w)} ${w}w`).join(", ");

export const IMG = {
  hero: "photo-1600210491892-03d54c0aaf87",
  lvp: "photo-1649083048770-82e8ffd80431",
  oak: "photo-1656122381069-9ec666d95cf1",
  oak2: "photo-1648475236583-2e25a6cbf3bd",
  bedroom: "photo-1560185893-a55cbc8c57e8",
  bedroom2: "photo-1710224002849-a76ea1068b0d",
  install: "photo-1731185752376-a4cf3e8556fa",
  install2: "photo-1624574470112-46944be68409",
  remodel: "photo-1608752503578-52f35965e3d9",
  warehouse: "photo-1689942010216-dc412bb1e7a9",
  forklift: "photo-1620388640785-892616248ec8",
  construction: "photo-1656733911001-16912b79d2bf",
  framing: "photo-1704742950992-9815a104820c",
  kitchen: "photo-1628745277862-bc0b2d68c50c",
  bright: "photo-1628744876497-eb30460be9f6",
  living: "photo-1712878696627-fd59c375dbb1",
  living2: "photo-1649083048381-520a5b3d91ff",
};
